
<template>
  <!--新增推送-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
    :itemLayout="$store.state.long_itemLayout"
  >
    <template slot="publishTime" slot-scope="{formItem}">
      <a-form-item class="publish-time" :label="formItem.label" required v-bind="$store.state.long_itemLayout">
        <a-row type="flex">
          <a-col>
            <a-form-item>
              <a-radio-group @change="publishChange" v-decorator="formItem.props">
                <a-radio :value="0">立即发布</a-radio>
                <a-radio :value="1">定时发布</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col>
            <a-form-item>
              <a-date-picker v-decorator="formItem.dateProps" :disabled="formItem.pickerDisabled" showTime format="YYYY-MM-DD HH:mm:ss"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form-item>
    </template>
    <template slot="transfer" slot-scope="{formItem}">
      <a-form-item :label="formItem.label" required v-bind="$store.state.long_itemLayout">
        <Transfer ref="transfer"/>
      </a-form-item>
    </template>
  </x-addEdit>
</template>

<script>
import { fetchSelect, userRange } from '@/utils/mixins';
import { addEdit } from 'ant-design-vue-admin-x';
import Transfer from '../../transfer.vue';
export default {
  mixins: [fetchSelect, addEdit, userRange],
  name: 'addPush',
  components: {
    Transfer
  },
  data () {
    return {
      scopeList: [],
      rangeList: [],
      actionsList: [],
      selectList: [],
      currentTarget: '',
      base_itemLayout: {
        labelCol: {span: 5},
        wrapperCol: {span: 8}
      },
      formKey: {
        title: '',
        content: '',
        type: '',
        isDelay: '',
        delayTime: '',
        pushOs: '',
        pushApp: '',
        scopeType: '',
        scope: '',
        openType: '',
        intent: '',
        urlType: '',
        url: '',
        param: ''
      },
      formList: [
        {
          label: '推送标题',
          inputType: 'input',
          options: [],
          placeholder: '请输入推送标题',
          props: ['title', {
            validateTrigger: 'blur',
            rules: [
              {required: true, message: '请输入推送标题'},
              {min: 1, max: 50, message: '标题为1-50个字'},
              {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}
            ]
          }]
        },
        {
          label: '推送内容',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入推送内容',
          props: ['content', {
            validateTrigger: 'blur',
            rules: [
              {required: true, message: '请输入推送内容'},
              {min: 1, max: 100, message: '模板ID为1-100个字'},
              {pattern: this.REG.nonEmpty, message: this.MESSAGE.nonEmpty}
            ]
          }]
        },
        {
          slot: 'publishTime',
          label: '发布时间',
          inputType: 'radioGroup',
          options: [],
          pickerDisabled: true,
          props: ['isDelay', {
            initialValue: 0,
            rules: [{required: true, message: '请选择发布时间'}]
          }],
          dateProps: ['delayTime',
            {
              rules: [{required: false, message: '请选择定时发布时间'}]
            }
          ]
        },
        {
          label: '目标平台',
          inputType: 'checkboxGroup',
          options: [],
          placeholder: '',
          props: ['pushOs', {
            initialValue: [],
            rules: [{required: true, message: '请选择目标平台'}]
          }]
        },
        {
          label: '目标应用',
          inputType: 'radioGroup',
          options: [],
          placeholder: '',
          handle: e => {
            this.pushTarget(e);
            this.pushAppChange(e);
          },
          props: ['pushApp', {
            initialValue: 1,
            rules: [{required: true, message: '请选择目标应用'}]
          }]
        },
        {
          label: '用户范围',
          inputType: 'select',
          options: [],
          placeholder: '请选择用户范围',
          handle: this.handleUserRange,
          props: ['scopeType', {
            rules: [{required: true, message: '请选择用户范围'}]
          }]
        },
        {
          isShow: false,
          label: '选择城市',
          inputType: 'treeSelect',
          options: [],
          placeholder: '请选择城市',
          treeCheckable: true,
          key: 'city',
          handle: this.rangeCityChange,
          props: ['cityScope', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          slot: 'transfer',
          isShow: false,
          label: '选择小区',
          inputType: 'text',
          options: [],
          placeholder: '',
          key: 'community',
          showSelectAll: false,
          selectChange: this.rangeCommunitySelected,
          change: this.rangeCommunityChange,
          props: ['communityScope', {
            rules: [{required: true, message: '请选择小区'}]
          }],
          titles: ['小区列表', '已选']
        },
        {
          isShow: false,
          label: '输入账号',
          inputType: 'textarea',
          extra: '多个账号以英文“,”逗号隔开',
          key: 'account',
          props: ['accountScope', {
            rules: [{required: true, message: '请输入账号'}]
          }]
        },
        {
          label: '点击后续动作',
          inputType: 'select',
          options: [],
          placeholder: '请选择指定页面',
          handle: (e, param) => this.handleOpenType(e, param),
          props: ['openType', {
            rules: [{required: true, message: '请选择后续动作'}]
          }]
        },

        {
          label: 'URL类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择URL类型',
          key: 'urlType',
          props: ['urlType', {
            rules: [{required: true, message: '请选择指定页面'}]
          }]
        },
        {
          label: 'URL',
          inputType: 'input',
          options: [],
          placeholder: '输入要打开的URL',
          key: 'url',
          props: ['url', {
            rules: [
              {required: true, message: '请输入url链接'},
              {type: 'url', message: '请输入正确的url格式'}
            ]
          }]
        },

        {
          label: '指定页面',
          inputType: 'select',
          options: [],
          placeholder: '选择指定页面',
          key: 'page',
          props: ['intent', {
            rules: [{required: true, message: '请选择指定页面'}]
          }]
        }
      ],
      addParam: {
        url: '/push',
        reqHandle: this.reqHandle,
        resHandle: '' // this.addResHandle
      },
      editParam: {},
      detailParam: {
        url: '/push/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  mounted () {
    let keyArr = [
      'intent', 'urlType', 'url' // 推送通知点击后续动作的key
    ];
    this.formList.forEach((el) => {
      let isSame = keyArr.some(item => item === (el.props && el.props[0]));
      isSame && (el.isShow = false);
    });
  },
  methods: {
    getSelect () {
      this.$get({
        url: '/push/treeselect'
      }).then(res => {
        this.formList[4].options = res.data;
      });

      let paramArr = [];
      if (this.$route.query.id) {
        paramArr = [
          {index: 3, scope: 'formList', query: 'comu_application_platform', handle: data => { this.platformList = data; }},
          // {index: 4, scope: 'formList', query: 'comu_msg_aims', handle: data => { this.applicationList = data; }},
          {index: 5, scope: 'formList', query: 'comu_msg_scopeType'},
          {query: 'comu_push_action_type', handle: data => { this.selectList = data; }}
        ];
      } else {
        paramArr = [
          {index: 3, scope: 'formList', query: 'comu_application_platform'},
          // {index: 4, scope: 'formList', query: 'comu_msg_aims'},
          {index: 5, scope: 'formList', query: 'comu_msg_scope_type', handle: this.handleRangeSelect},
          {query: 'comu_push_action_type', handle: data => { this.selectList = data; }}
        ];
      }
      this.dictionarySelect(paramArr);

      this.userRangeList(6, 7);
    },
    /* 目标应用change */
    pushAppChange (e) {
      this.currentTarget = e.target.value;
      let currentOptions = [];
      this.formList[4].options.forEach(item => {
        if (this.currentTarget === item.value) {
          currentOptions = item.children;
        }
      });
      this.$refs.addEdit.form.resetFields(['openType', 'intent', 'urlType', 'url']);
      this.formList.forEach(item => {
        if (item.props && item.props[0] === 'openType') {
          item.options = currentOptions;
        }
      });
    },
    /* 处理点击后续动作输入框 */
    handleOpenType (val, param) {
      this.$refs.addEdit.form.resetFields('page', 'urlType', 'url');

      let keyObj = {
        open_app_page: 'page',
        open_link: 'urlType'
      };
      let openTypeObj = {
        open_app: { page: false, urlType: false, url: false },
        open_app_page: { page: true, urlType: false, url: false },
        open_link: { page: false, urlType: true, url: true }
      };
      for (let key in openTypeObj) {
        if (val === key) {
          this.formList.forEach(item => {
            if (item.props && item.props[0] === 'openType') {
              let list = [];
              item.options.forEach(el => {
                if (el.value === key && el.children) {
                  list = el.children;
                }
              });
              this.formList.forEach(el => {
                if (keyObj[val] && el.key === keyObj[val]) {
                  el.options = list;
                }
              });
            }
          });
        }
      }
      this.handleDynamicForm(val, openTypeObj);
    },
    /* 发布时间 change */
    publishChange (e) {
      this.handleDealyTime(e.target.value);
    },
    /* 处理用户范围 */
    handleUserRange (val) {
      let userTypeObj = {
        0: { city: false, community: false, account: false },
        1: { city: true, community: false, account: false },
        2: { city: false, community: true, account: false },
        3: { city: false, community: false, account: true }
      };
      this.handleDynamicForm(val, userTypeObj);
    },
    reqHandle (param) {
      let arealist = this.$refs.transfer && this.$refs.transfer.targetKeys;
      if (param.scopeType == 2 && arealist.length == 0) {
        this.$message.error('请选择小区');
        return;
      }
      if (param.scopeType == 2 && arealist.length != 0) {
        param.communityScope = arealist;
      }

      param.delayTime && (param.delayTime = param.delayTime.format('YYYY-MM-DD HH:mm:ss'));
      if (new Date(param.delayTime).getTime() < new Date().getTime()) {
        this.$message.error('推送时间不能小于当前时间');
        return;
      }
      param.type = 1; // 默认提交消息类型为公告
      param.urlType && (param.intent = param.urlType);
      param = this.rangeReqVal(param);
      if (param.scope.length && param.scopeType !== '3' && param.scopeType !== '0') {
        param.scope = param.scope.join(',');
      }
      if (param.cityScope && param.cityScope.length) {
        delete param.cityScope;
      }
      param.pushOs = Array.isArray(param.pushOs) ? param.pushOs.join() : param.pushOs;
      return param;
    },
    addResHandle (res) {
      console.log('处理添加返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>
